
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Alert } from "@/addons/Alert";
import { DateTime } from "luxon";
import { useConsultorioStore } from '../../store/consultorioStore';
import { globalStore } from '../../store/globalStore';
import { consultorioService } from '../../services/ConsultorioService';
import { http } from "@/config/HttpClient";
import { AxiosResponse } from "axios";

@Component({
	name: "Historial",
})

export default class Historial extends Vue {
	@Prop() paciente_id!: any
	private globalStore = globalStore();
	private consultorioStore = useConsultorioStore();
	private consultorioService = consultorioService.getInstance();
	
	valid = true;
	fecha = DateTime.now().toFormat('yyyy-MM-dd');
	historial = []
	id = 0
	panel = []
	reconsulta = {
		id: '',
		fecha: DateTime.now().toFormat("yyyy-MM-dd"),
    hora: DateTime.now().toFormat("HH:mm"),
		cita_id: '',
		detalle: ''
	}
	reconsultas = []
	swEditar = false
	mounted() {
		this.id = Number(this.$route.query.id)
		console.log(this.$route.query.id)
		this.getHistorial()
	}
	get citas(): any {
		return this.consultorioStore.citas;
	}
	async getHistorial() {
		
		await http.get(`getHistorial/${this.id}`).subscribe({
			next: (response:AxiosResponse) => {
				this.consultorioStore.citas = response.data
				this.historial = response.data;
			},
		})
	}
	async guardar() {
		if (!this.$refs.form.validate()) {
			Alert.warning(`Lene todos los campos obligatorios (*)`)
			return;
		}

		if (!this.swEditar) {
			Alert.confirm(`Se realizará el registro de la reconsulta `, 'Registrar reconsulta?').then(async result => {
				if (result.isConfirmed) {
					await this.consultorioService.registrarReconsulta(this.reconsulta).then(response => {
						this.limpiar()
						this.getHistorial()
					})

				}
			})
		} else {
			Alert.confirm(`Se realizará la modificacion de la venta`, 'Modificar venta?').then(async result => {
				if (result.isConfirmed) {
					await this.consultorioService.editarVenta(this.venta)
					this.limpiar()
				}
			})
		}
	}
	
	limpiar() {
		this.reconsulta = {
			id: '',
			fecha: DateTime.now().toFormat("yyyy-MM-dd"),
			hora: DateTime.now().toFormat("HH:mm"),
			cita_id: '',
			detalle: ''
		}
	}
	seleccionarCita(reconsultas: any) {
		this.reconsultas = reconsultas
	}
	eliminarReconsulta(id: number) {
		Alert.confirm(`Se eliminará la reconsulta `, 'Eliminar reconsulta?').then(async result => {
				if (result.isConfirmed) {
					await this.consultorioService.eliminarReconsulta(id).then(response => {
						this.limpiar()
						this.getHistorial()
						this.reconsultas = []
					})

				}
			})
	}
	async imprimirConcentimiento() {
		await http.get(`imprimir-concentimiento/${this.id}`).subscribe(response =>{
			window.open(
				`${process.env.VUE_APP_URL}imprimir-concentimiento/${this.id}`, "_blank");
		})
	}
	
	
}

